import { Colors } from "design/colors";
import {
    FaultCode,
    ControllerState,
} from "utils/common-types";
import {
    camelCaseToReadable,
    controllerStateToString,
    faultCodeToString,
} from "utils/common";
import { TelemValue } from "cstore/telem";
import { useSingleTelemetryValue } from "hooks/useSingleTelemetryValue";
import { REFRESH_MS } from "hooks/usePlayback";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faXmark } from "@fortawesome/free-solid-svg-icons";
import { PlotKey } from "utils/packet.worker";
import { displayUnit, plotKeyToMultiMotorInfo } from "utils/packet-workers";
import { actuatorDispositionStyle } from "design/colors";

export interface IGaugeWidgetProps {
    close: () => void;
}

export interface IGaugeProps {
    packetKey: PlotKey;
}

export const Gauge = ( props: IGaugeProps & IGaugeWidgetProps ): JSX.Element => {
    const latestValue: TelemValue | undefined = useSingleTelemetryValue( props.packetKey, REFRESH_MS );

    if ( latestValue === undefined ) return <></>;

    let text = "---";
    if ( typeof latestValue === "number" ) {
        text = `${ latestValue.toFixed( 3 ) } ${ displayUnit( props.packetKey ) }`;
    } else if ( typeof latestValue === "boolean" ) {
        text = latestValue.toString();
    }
    if ( props.packetKey === "controllerState" && typeof latestValue !== "boolean" ) {
        if ( !isFinite( latestValue) || !( latestValue in ControllerState ) ) {
            // ToDo: I wish there was a way of also swapping the state when Gauges get swapped by drag-and-drop
            text = "---";
        } else {
            let controllerState: ControllerState = latestValue;
            text = controllerStateToString( controllerState );
        }
    } else if ( props.packetKey === "faultCodeDeprecated" && typeof latestValue !== "boolean" ) {
        // TODO: remove this block after a few months of FaultControl widget in prod
        if ( !isFinite( latestValue) || !( latestValue in FaultCode ) ) {
            // ToDo: I wish there was a way of also swapping the state when Gauges get swapped by drag-and-drop
            text = "---";
        } else {
            let faultCode: FaultCode = latestValue;
            text = faultCodeToString( faultCode );
        }
    }

    const multiMotorInfo = plotKeyToMultiMotorInfo( props.packetKey );
    const baseName = multiMotorInfo?.baseName ?? props.packetKey;
    const multiMotorLabel = multiMotorInfo
                              ? ( <span style={actuatorDispositionStyle}>
                                    {multiMotorInfo.label}
                                  </span> )
                              : null;
    return (
        <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", flex: "column" }}>
                    {/* Drag and drop drag handle */}
                    <FontAwesomeIcon
                        icon={ faGripVertical }
                        color={ Colors.WHITE }
                        style={{ padding: "0px 8px 0px 0px", cursor: "pointer" }}
                        size="lg"
                    />
                    <div style={{ color: Colors.WHITE }}>{multiMotorLabel} { camelCaseToReadable( baseName ) }</div>
                </div>
                <FontAwesomeIcon
                    icon={ faXmark }
                    color={ Colors.WHITE }
                    style={{ padding: "0px 4px", cursor: "pointer" }}
                    onClick={ props.close }
                    size="lg"
                />
            </div>
            <div style={{ display: "flex", flex: 1, fontSize: 48, color: Colors.WHITE, justifyContent: "center", alignItems: "center" }}>
                { text }
            </div>
        </div>
    );
};
